import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Push, PushObject, PushOptions } from '@ionic-native/push';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { LoginPage } from '../pages/login/login';
import { GlobalProvider } from '../providers/global/global';
import { ConsultaPage } from '../pages/consulta/consulta';
import { ClientPage } from '../pages/client/client';
import { AmbientPage } from '../pages/ambient/ambient';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { BannerAlarmPage } from '../pages/banner-alarm/banner-alarm';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  pag: string;
  component: any;
  index: number;
  change: boolean = false;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private push: Push,
    public global: GlobalProvider,
    private inAppB: InAppBrowser,
  ) {
    this.initializeApp();

    if (this.platform.is('android')) 
    {
      this.global.devicePlatform = "android";
    }
    else if (this.platform.is('ios')) 
    {
      this.global.devicePlatform = "ios";
    }
    else if (this.platform.is('core') || this.platform.is('mobileweb'))
    {
      this.global.devicePlatform = "browser";
    }

    if (this.global.permissions.length > 1)
    {
      this.change = true;
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.pushSetup();
    });
  }

  openPage(pag) {
    if (pag == "ListPage")
    {
      this.component = ListPage;
    }
    else if (pag == "ConsultaPage")
    {
      this.component = ConsultaPage;
    }
    else if (pag == "HomePage")
    {
      this.component = HomePage;
    }
    else if (pag == "BannerAlarmPage")
    {
      this.component = BannerAlarmPage;
    }
    else
    {
      this.global.menu = pag;
      this.component = AmbientPage;
    }

    this.nav.setRoot(this.component);
  }

  change_client() {
    this.nav.setRoot(ClientPage);
  }

  acess_privacyPolicy(){
    const url = 'http://iot.digicomp.com.br/privacy_policy.html';
    let target ="_blank";

    this.inAppB.create(url, target);
  }


  logout(){
    localStorage.setItem('storedLogin', null);
    localStorage.setItem('storedrf', null);
    this.nav.setRoot(LoginPage);
  }

  pushSetup(){
        const options: PushOptions = {
       android: {
         senderID: '789108610849'
       },
       ios: {
           alert: 'true',
           badge: true,
           sound: 'false'
       }
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => console.log('Received a notification', notification));

    pushObject.on('registration').subscribe((registration: any) => {
      //console.log('Device registered', registration);
      this.global.regId = registration.registrationId;
    });

    pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts